export enum DocFormat {
  Csv = "csv",
  Pdf = "pdf",
  Doc = "doc"
}
